export const CURRENCY = '€'
export const EXTENSION_MIMETYPE: Record<string, string> = Object.freeze({
  pdf: 'application/pdf',
  jpg: 'image/jpeg',
  jpeg: 'image/jpeg',
  png: 'image/png'
})
